import axios from 'axios'

export type BackendVersionResponse = {
  version: string
}

export const getBackendVersion = () => {
  return axios.get<BackendVersionResponse>(`${process.env.VUE_APP_API_URL}/version`)
}